export const GET_ROUTES_REQUEST = "GET_ROUTES_REQUEST";
export const GET_ROUTES_SUCCESS = "GET_ROUTES_SUCCESS";
export const GET_ROUTES_FAILURE = "GET_ROUTES_FAILURE";
